import React from "react";

import i18n from "i18n-react";
import { HashLink as Link } from "react-router-hash-link";

const params = new URLSearchParams(window.location.search);
let termsUri = "/main/rewards";
let mobile = false;
if (params.get("mobile")) {
  mobile = true;
  termsUri = "/main/rewards?mobile=true";
}

const TermsAndConditionsView = () => (
  <div className="contentContainer BookingForm TermsAndConditions">
    <div className="header">
      <h3>{i18n.translate("rewards.TermsAndConditions.title")}</h3>
    </div>
    <div className="bodyRewardsTerms">
      <p className="text--bold">Eligibility</p>
      <p>
        Only graduates of the St. Kitts Trav Pros course are eligible and
        entitled to participate, earn entries, and redeem rewards.
      </p>
      <ul>
        <li>
          The bookings contest is valid for Travel Advisors only, not
          agencies/groups/companies. Participation is individual and valid
          wherever you work or may work, for as long as this program is in
          effect.{" "}
        </li>
      </ul>

      <p className="text--bold">Conditions</p>
      <p>
        Only Lodging and Ground Services, including Car Rental, qualify as
        bookings to earn entries. Air and Cruise bookings do not qualify.
      </p>
      <ul>
        <li>Earn one entry for each lodging booking of 3 nights or more.</li>
        <li>
          Earn one entry for 3 or more Ground Services booked (e.g., Meet &
          Greet, transfer, sightseeing).
        </li>
        <li>Earn one entry for each Car Rental booking of 3 days or more.</li>
        <li>
          Bookings must be entered on the Submit Bookings page in the Rewards
          Center and may be tracked in the Bookings Dashboard.
        </li>
        <li>
          Valid bookings entered between the first and last day of the month
          will be eligible to win the monthly cash prizes.
        </li>
        <li>
          The travel advisor with the highest number of qualified bookings each
          month will be awarded{" "}
          <span className="text--bold">one (1) $250 Gift Card</span>.
        </li>
        <li>
          A random drawing for{" "}
          <span className="text--bold">two (2) $100 Gift Cards</span> will be
          made on or close to the first of the month for travel advisors
          entering qualified bookings during the month prior.
        </li>
        <li>
          All winners will be notified and receive their gift cards by email.
        </li>
      </ul>

      <p className="text--bold">Fiscal Responsibility</p>
      <ul>
        <li>
          You must represent yourself and act as a legitimate travel advisor or
          seller of travel, member of ASTA, ARC, IATA, CLIA, or part of a Host
          Agency, Travel Consortium, or Travel Conglomerate duly licensed under
          the laws of your country of residence and subject to the laws of the
          United States of America and the laws of the Commonwealth of Puerto
          Rico.
        </li>
        <li>
          You are responsible for reporting any sales revenues to the proper
          authorities of your country, or those of the country where the travel
          originated. Awards may or not be exempt according to the laws of your
          country or that of the passenger where travel originated.
        </li>
        <li>Other conditions may apply.</li>
        <li>
          This is an adhesion agreement, Participants accept the terms and
          conditions of St. Kitts Trav Pros, and all its decisions as final.
        </li>
        <li>
          Any participants misrepresentations, the submission of false
          information, or any act considered misconduct will forfeit
          participation and all earned points and may risk liability for
          prosecution under the law.
        </li>
        <li>
          Participants agree that the prevailing law is that of the Commonwealth
          of St. Kitts Trav Pros for all purposes relating to this program.
        </li>
        <li>All terms and conditions are subject to change without notice.</li>
      </ul>

      <br />
      <hr />

      <div className="buttonHolder">
        <Link to={termsUri}>
          <button className="btn" type="button">
            {i18n.translate("rewards.TermsAndConditions.button")} &gt;
          </button>
        </Link>
      </div>
    </div>

    {mobile && (
      <style>
        {
          "\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }"
        }
      </style>
    )}
  </div>
);

export default TermsAndConditionsView;
